import React from "react";
import { Helmet } from "react-helmet";
import StaticPageStyle from "./StaticPageStyle";

const TermsOfService = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Terms of Service — Propeller PH</title>
        <meta
          name="description"
          content="The terms that govern your use of propeller.ph, including how listing information may be used and our disclaimers and limitations of liability."
        />
        <link
          rel="canonical"
          href="https://www.propeller.ph/terms-of-service"
        />
      </Helmet>
      <StaticPageStyle>
        <div className="container">
          <h1>Terms of Service</h1>
          <p className="page-meta">Last updated: July 10, 2026</p>

          <p>
            These Terms of Service ("Terms") govern your access to and use of{" "}
            <a href="https://www.propeller.ph">www.propeller.ph</a> (the
            "Site"), operated by Propeller Realty Investments ("Propeller PH",
            "we", "us", or "our"), a real estate agency based in Metro Manila,
            Philippines. By using the Site, you agree to these Terms. If you do
            not agree, please do not use the Site.
          </p>

          <h2>About the Site</h2>
          <p>
            The Site is a property listing platform where you can browse
            residential and commercial real estate offered for sale or lease in
            the Philippines, view property details, and send inquiries to us
            about specific listings or our services.
          </p>

          <h2>Listing information</h2>
          <p>
            We work to keep listing information accurate and current, but all
            property details — including prices, availability, dimensions,
            features, and photographs — are provided for general information
            only and may change or contain errors. Listings do not constitute
            an offer, and photographs may not reflect a property's current
            condition. Before making any decision to purchase or lease, you
            should independently verify all information, inspect the property,
            and confirm the final terms with us or the responsible broker or
            owner.
          </p>

          <h2>No professional advice</h2>
          <p>
            Content on the Site is not legal, financial, tax, or investment
            advice. Consult qualified professionals before entering into any
            real estate transaction.
          </p>

          <h2>Acceptable use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>
              Use the Site for any unlawful purpose or in a way that could
              damage, disable, or impair it;
            </li>
            <li>
              Scrape, harvest, or systematically extract data from the Site
              without our prior written consent;
            </li>
            <li>
              Submit false or misleading information through our inquiry or
              listing forms;
            </li>
            <li>
              Attempt to gain unauthorized access to any part of the Site or
              its systems.
            </li>
          </ul>

          <h2>Intellectual property</h2>
          <p>
            The Site and its content — including the Propeller PH name, logo,
            page designs, and text — are owned by or licensed to Propeller
            Realty Investments and are protected by intellectual property laws.
            Property photographs and descriptions may belong to their
            respective owners and are used with permission. You may view and
            share links to the Site, but you may not reproduce its content for
            commercial purposes without our consent.
          </p>

          <h2>Advertising and third-party content</h2>
          <p>
            The Site displays advertising served by third parties, including
            Google AdSense, and links to third-party websites and services
            (such as social media pages and Google Forms). We do not control
            and are not responsible for the content, products, or services of
            third parties. See our{" "}
            <a href="/privacy-policy">Privacy Policy</a> for how advertising
            cookies are used and how to opt out of personalized ads.
          </p>

          <h2>Disclaimer of warranties</h2>
          <p>
            The Site is provided on an "as is" and "as available" basis. To the
            fullest extent permitted by law, we disclaim all warranties,
            express or implied, including warranties of merchantability,
            fitness for a particular purpose, and non-infringement. We do not
            warrant that the Site will be uninterrupted, error-free, or free of
            harmful components.
          </p>

          <h2>Limitation of liability</h2>
          <p>
            To the fullest extent permitted by law, Propeller Realty
            Investments shall not be liable for any indirect, incidental,
            special, or consequential damages arising from your use of the
            Site or your reliance on any listing information, even if we have
            been advised of the possibility of such damages. Nothing in these
            Terms limits liability that cannot be limited under Philippine
            law.
          </p>

          <h2>Changes to the Site and these Terms</h2>
          <p>
            We may modify or discontinue any part of the Site at any time. We
            may also update these Terms; the "Last updated" date above shows
            the latest revision. Your continued use of the Site after changes
            take effect constitutes acceptance of the revised Terms.
          </p>

          <h2>Governing law</h2>
          <p>
            These Terms are governed by the laws of the Republic of the
            Philippines. Any dispute arising from these Terms or your use of
            the Site shall be subject to the exclusive jurisdiction of the
            courts of Pasig City, Philippines.
          </p>

          <h2>Contact us</h2>
          <p>Questions about these Terms? Reach us at:</p>
          <ul>
            <li>
              Email:{" "}
              <a href="mailto:propeller.realty@gmail.com">
                propeller.realty@gmail.com
              </a>
            </li>
            <li>
              Phone: <a href="tel:+639060012922">+63 906 001 2922</a>
            </li>
            <li>Address: West Capitol Drive, Kapitolyo, Pasig, Philippines</li>
          </ul>
        </div>
      </StaticPageStyle>
    </React.Fragment>
  );
};

export default TermsOfService;
